import { createAction } from "redux-actions";

export const GET_ALL_USER= "GET_ALL_USER";
export const getAllUser= createAction(GET_ALL_USER);

export const DELETE_USER = "DELETE_USER";
export const deleteUser = createAction(DELETE_USER);


